import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';

const FloatingShapes = ({ isDarkMode = false }) => {
  const shapesRef = useRef([]);

  const shapes = [
    { type: 'cube', color: '#A37A00', position: [-2, 1, -3], size: [0.5, 0.5, 0.5] },
    { type: 'sphere', color: '#8A6800', position: [2, -1, -4], size: [0.4] },
    { type: 'cylinder', color: '#715600', position: [-3, -2, -2], size: [0.3, 0.3, 0.6] },
    { type: 'cone', color: '#B88A00', position: [3, 2, -5], size: [0.3, 0.6] },
    { type: 'torus', color: '#9C7200', position: [0, 0, -6], size: [0.3, 0.1] },
    { type: 'octahedron', color: '#A37A00', position: [-1, -3, -3], size: [0.4] },
  ];

  useFrame((state) => {
    shapesRef.current.forEach((shape, i) => {
      if (shape) {
        shape.position.y = Math.sin(state.clock.elapsedTime + i) * 0.2 + shapes[i].position[1];
        shape.rotation.x += 0.01;
        shape.rotation.y += 0.005;
      }
    });
  });

  return (
    <group>
      {shapes.map((shape, index) => {
        const props = {
          position: shape.position,
          ref: (el) => (shapesRef.current[index] = el),
        };

        let geometry;
        switch (shape.type) {
          case 'cube':
            geometry = <boxGeometry args={shape.size} />;
            break;
          case 'sphere':
            geometry = <sphereGeometry args={shape.size} />;
            break;
          case 'cylinder':
            geometry = <cylinderGeometry args={shape.size} />;
            break;
          case 'cone':
            geometry = <coneGeometry args={shape.size} />;
            break;
          case 'torus':
            geometry = <torusGeometry args={shape.size} />;
            break;
          case 'octahedron':
            geometry = <octahedronGeometry args={shape.size} />;
            break;
          default:
            geometry = <boxGeometry args={shape.size} />;
        }

        return (
          <mesh key={index} {...props}>
            {geometry}
            <meshStandardMaterial
              color={shape.color}
              emissive={shape.color}
              emissiveIntensity={isDarkMode ? 0.3 : 0.15}
              metalness={isDarkMode ? 0.6 : 0.4}
              roughness={isDarkMode ? 0.2 : 0.3}
              transparent
              opacity={isDarkMode ? 0.8 : 0.9}
            />
            <pointLight
              color={shape.color}
              intensity={isDarkMode ? 0.5 : 0.3}
              distance={5}
              decay={2}
            />
          </mesh>
        );
      })}
    </group>
  );
};

export default FloatingShapes;